<template>
    <div class="row card-body" style="padding-top: 0px;padding-bottom: 5em;" id="editContactMe">
        <div class="card-header window-header" style="margin: 0px -10px 0px -10px; width: 105%;">
            <h4>{{ lang.ecm_contact_us }}</h4>
		</div>
        <div class="window-body">
            <div class="row" v-if="isLoading">
                <div class="col-md-12 " >
                    <div class="loadingImg">
                        <Loader></Loader>
                    </div>
                </div>
            </div>
            <template v-else>
                <div class="row" v-for="(i, index) in contact_me" :key="'contactUs-'+index">
                    <div class="col-1 text-center"></div>
                    <div class="col-8 ">
                        <label class="col-form-label" style="text-transform: capitalize;">
                            <span v-if="i.type!=='about_me'">{{ i.type }}</span> <span v-else>{{ lang.ecm_about_me }}</span>
                        :</label>
                        <div class="input-group" :style="(i.type=='about_me') ? {'border':'0px'} : ''">
                            <span class="input-group-text"><i :class="[i.type=='call' ? 'fa fa-phone' : i.type=='email' ? 'fa fa-envelope' : i.type=='address' ? 'fas fa-map-marked-alt' : 'fa fa-info']"></i></span>
                            <input type="text" class="form-control"
                                v-model="i.value"
                                :placeholder="i.type=='call' ? lang.ecm_phone_ph : i.type=='email' ? lang.ecm_email_ph : i.type=='address' ? lang.ecm_address_ph : ''"
                                @change="setContactMe"
                                v-if="i.type !== 'about_me'"
                            />
                            <vue-editor
                            v-else
                            v-model="i.value"
                            :editor-toolbar="customToolbar"
                            class="form-control descrip_about_me"
                            :placeholder="lang.ecm_about_ph"
                            @blur="setContactMe"
                            />
                        </div>
                    </div>
                    <div class="col-2 text-center">
                        <label class="col-form-label">{{ lang.ec_show }}</label>
                        <div class="onoffswitch" >
                            <input
                                type="checkbox"
                                class="onoffswitch-checkbox"
                                :id="'status-'+i.type+'-'+index"
                                v-model="i.status"
                                :value="1"
                                @change="setContactMe"
                            />
                            <label class="onoffswitch-label" :for="'status-'+i.type+'-'+index" >
                                <span class="onoffswitch-inner"></span>
                                <span class="onoffswitch-switch"></span>
                            </label>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import Loader from '../../../../../core/components/shared/Loader.vue';
import { mapGetters } from "vuex";
import { VueEditor } from 'vue2-editor'
import './editContactaMe.scss';
export default {
    name: "editContactMe",
    components: {
        Loader,
        VueEditor,
    },
    data() {
        return {
            isLoading: false,
            contact_me: [],
            lang: {
                ecm_contact_us: '',
                ecm_about_me: '',
                ecm_phone_ph: '',
                ecm_email_ph: '',
                ecm_address_ph: '',
                ecm_about_ph: '',
                ec_show: '',
                ec_fail: '',
                ec_failed_save: '',
            },
            customToolbar: [
                [
                    "bold",
                    "underline",
                    "clean"
                ]
            ],
        }
    },
    mounted() {
        this.lang = this.$store.getters['ModApps/Marketea/lang'];
        this.getContactMe();
    },
    computed: {
        ...mapGetters("ModApps/Marketea", {
            cardItem: "get_bsite_cardItem",
            langGetter: "lang",
        }),
    },
    watch: {
        langGetter() {
            this.lang = this.$store.getters['ModApps/Marketea/lang'];
        },
    },
    methods: {
        find_me_at() {
            // @ts-ignore
            const list = (this.$parent && this.$parent.item && Array.isArray(this.$parent.item.find_me_at))
                // @ts-ignore
                ? this.$parent.item.find_me_at
                : [];
            // @ts-ignore
            list.filter(f => {
                if(f.slug == 'call' || f.slug == 'email'){
                    this.contact_me.push({
                        type: f.slug,
                        value: f.val,
                        status: f.status
                    })
                }
            });
            // Asegurarse de que los tipos 'call' y 'email' estén presentes en contact_me.
            ['call', 'email', 'address', 'about_me'].forEach(type => {
                // @ts-ignore
                if(!this.contact_me.find(c => c.type === type)){ // Si no existe, agregarlo con valor vacío y status 0.
                    // @ts-ignore
                    let newItem = {
                        type: type,
                        value: '',
                        status: 0
                    };
                    this.contact_me.push(newItem);
                }
            });
            // console.log('contact_me', this.contact_me)
            this.isLoading = false;
        },
        getContactMe() {
            let t = this;
            t.isLoading = true;
            let getData = {
                user_id: window.master_client,
                org_id: window.localorgdata,
                template_id: t.cardItem.template_id,
                id: t.cardItem.id, // about_id
                meta_key: 'contact_me',
            }
            window.master
            .post("getOptionsTemplate", getData)
            .then(r => {
                console.log('getOptionsTemplate', r);
                if(r.data && r.data.status){
                    let d = JSON.parse((r.data.data && r.data.data.meta_value) || '[]');
                    if(d.length > 0){
                        t.contact_me = d.map((item = {}) => {
                            let hasStatus = Object.prototype.hasOwnProperty.call(item, 'status');
                            let type = item.type || '';
                            let value = item.value || '';
                            let status = hasStatus ? item.status : (type == 'call' || type == 'email' ? !0 : !1);
                            return {
                                type,
                                value,
                                status
                            };
                        });
                        ['call', 'email', 'address', 'about_me'].forEach(type => {
                            // @ts-ignore
                            if(!this.contact_me.find(c => c.type === type)){ // Si no existe, agregarlo con valor vacío y status 0.
                                // @ts-ignore
                                let newItem = {
                                    type: type,
                                    value: '',
                                    status: 0
                                };
                                this.contact_me.push(newItem);
                            }
                        });
                    }
                }
                if(t.contact_me.length === 0){
                    t.find_me_at();
                }else{
                    t.isLoading = false;
                }
            })
            .catch(error => {
                console.log(error);
                t.isLoading = false;
                t.$notify({
                    group: "noti",
                    type: 'Error',
                    title: this.lang.ec_fail,
                    text: this.lang.ec_failed_save,
                    duration: 2000
                });
            });
        },
        setContactMe() {
            let t= this;
            let formData = new FormData();
            // @ts-ignore
            formData.append("user_id", window.master_client);
            // @ts-ignore
            formData.append("org_id", window.localorgdata);
            formData.append("id", t.cardItem.id);
            formData.append("template_id", t.cardItem.template_id);
            formData.append("meta_key", 'contact_me');
            formData.append("meta_value", JSON.stringify(t.contact_me));
            formData.append("pusher_id", pusher.connection.socket_id);
            t.$store.dispatch('ModApps/Marketea/setTempOpts', formData)
            .then(r => {
                console.log('setOptionsTemplate', r);
                t.isLoading = false;
                setTimeout(() =>{
                    this.$parent.$emit('closed-lateral');
                }, 400);
            })
            .catch(error => {
                console.log(error);
                t.isLoading = false;
                t.$notify({
                    group: "noti",
                    type: 'Error',
                    title: this.lang.ec_fail,
                    text: this.lang.ec_failed_save,
                    duration: 2000
                });
            });
        }
    }
}
</script>
<style scoped lang="scss">
.window-header{cursor: move;}
.marginTop{margin-top: 20px;}
.card-header h4{font-size:24px;margin-bottom: 0px;}
.onoffswitch{
    &.disabled{
        .onoffswitch-label{
            .onoffswitch-inner{
                &:before, &:after {
                    background-color: #c3c3c4 !important;
                    color: #555;
                }
            }
        }
    }
    .onoffswitch-label{
        .onoffswitch-inner{
            &:before{
                padding-left: 10px;
            }
        }
    }
}
.switchDisabled {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgb(221 221 221 / 50%);
    z-index: 2;
    border-radius: 20px;
}
.window-body{
    position: relative;
    width: 100%;
    margin: auto;
    height: 500px;
    border: 0px solid #000;
    margin-bottom: 2em;
    overflow: hidden;
    overflow-y: auto;
}
@media (max-width:767px){
    .window-body{
        height: 100%;
        max-height: 800px;
        padding-bottom: 20em;
    }
}
</style>
